import { Alert, AlertProps } from '@snack-uikit/alert';
import { ValueOf } from '@snack-uikit/utils';

import { DYNAMIC_CONTENT_CLASS_NAMES } from '@/constant/dynamic';
import { DATA_TEST_IDS_INJECTORS } from '@/constant/tests';
import { applyToIndex, complement, equals, isOneOf } from '@/utils/common';
import { removeEmptyStrings } from '@/utils/strings';

import { collectTextContent } from '../utils';
import s from './styles.module.scss';
import { getNodeClass, makeInjector } from './utils';

const expectedClassnames = [
  DYNAMIC_CONTENT_CLASS_NAMES.hint,
  DYNAMIC_CONTENT_CLASS_NAMES.seealso,
  DYNAMIC_CONTENT_CLASS_NAMES.note,
  DYNAMIC_CONTENT_CLASS_NAMES.attention,
] as const;

const getAlertAppearance = (nodeClass: ValueOf<typeof expectedClassnames>): AlertProps['appearance'] => {
  const nodeClassIs = equals(nodeClass);
  if (nodeClassIs(DYNAMIC_CONTENT_CLASS_NAMES.note)) return 'primary';
  if (nodeClassIs(DYNAMIC_CONTENT_CLASS_NAMES.hint)) return 'info';
  if (nodeClassIs(DYNAMIC_CONTENT_CLASS_NAMES.attention)) return 'warning';
  return 'neutral';
};

const isValidClass = isOneOf(expectedClassnames);

const TITLE_ELEMENT_INDEX = 0;

const isEqualsWithTitleIx = equals(TITLE_ELEMENT_INDEX);

export const hintToSnackAlertInjector = makeInjector((node, children) => {
  const nodeClass = getNodeClass(node);

  if (!isValidClass(nodeClass)) return null;

  const cleanChildren = removeEmptyStrings(children);

  const title = collectTextContent(cleanChildren[TITLE_ELEMENT_INDEX]).join(' ');

  return (
    <Alert
      data-test-id={DATA_TEST_IDS_INJECTORS.hints}
      className={s.alert_wrapper}
      outline
      size='m'
      appearance={getAlertAppearance(nodeClass)}
      title={title}
      description={cleanChildren.filter(applyToIndex(complement(isEqualsWithTitleIx)))}
    />
  );
});
